import homePage from '@/components/homePage/index.vue';
export default {
  path: '/personal',
  component: homePage,
  redirect: '/personal/index',
  meta: { title: "系统设置" },
  children: [
    {
      path: "index",
      component: () => import('@/module/personalModule/viewPages/index.vue'),
      meta: { title: "个人中心" },
    }
  ]
}